import actions from "./actions"
import { StanZadania } from "../../utils/stanZadania"

const initialState = {
    paymentsAll: [],
    paymentStatuses: [],
    // "idle" - zadanie jeszcze nie wyszlo. Bez tego stanu ekran pokazywal
    // "Brak danych" przy pierwszym renderowaniu, przed zapytaniem API.
    paymentsAllStan: "idle" as StanZadania
};

export default function paymentsReducers(state = initialState, action:{payload: any, type: any}):any{
    switch(action.type){
        case actions.SET_ALL_PAYMENTS:
            return {...state, paymentsAll: action.payload, paymentsAllStan: "ok"};
        case actions.SET_ALL_PAYMENTS_LOADING:
            return {...state, paymentsAllStan: "loading"};
        case actions.SET_ALL_PAYMENTS_ERROR:
            return {...state, paymentsAllStan: "error"};
        case actions.SET_PAYMENT_STATUSES:
            return {...state, paymentStatuses: action.payload};
        default:
            return state;
    }
}
